import api from './utils/api';

class ValuesService {
  async listValues() {
    const result = await api.get('/values');
    return result.data;
  }

  async listModelValues(id) {
    const result = await api.get(`/model-value/${id}`);
    return result.data;
  }

  async upsertModelValues(data) {
    const result = await api.put('/model-value', data);

    return result.data;
  }

  async deleteModelValue(id) {
    const result = await api.delete(`/model-value/${id}`);
    return result.data;
  }
}

export default new ValuesService();
